import { render, staticRenderFns } from "./invoiceinfo.vue?vue&type=template&id=5b95a0cd&scoped=true"
import script from "./invoiceinfo.vue?vue&type=script&lang=js"
export * from "./invoiceinfo.vue?vue&type=script&lang=js"
import style0 from "./invoiceinfo.vue?vue&type=style&index=0&id=5b95a0cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b95a0cd",
  null
  
)

export default component.exports